module.exports = __webpack_public_path__ + "static/media/search.79617441.svg";